import { FiltersV2EventHandlers, FilterV2Event, useFiltersV2EventsBus } from "PFApp/components/filters_v2";
import { useEffect } from "react";

export const useOnFiltersUpdate = (action: FiltersV2EventHandlers[FilterV2Event.FiltersUpdate]) => {
  const eventsBus = useFiltersV2EventsBus();

  useEffect(() => {
    eventsBus.on(FilterV2Event.FiltersUpdate, action);

    return () => {
      eventsBus.removeListener(FilterV2Event.FiltersUpdate, action);
    };
  }, [eventsBus, action]);
};
